import { createSelector } from 'reselect';

import { selectEntitiesMissionsEntityAchievementIds } from '../../../../selectors/entities/missions/entitiesMissionsPrimary.selector';
import { Selector } from '../../../../types/selectors';

type MissionDetailsAchievementsListContainerPropsType = {
  achievementIds: Array<number>;
};

const selectMissionDetailsAchievementsListContainerProps: Selector<MissionDetailsAchievementsListContainerPropsType> =
  createSelector([selectEntitiesMissionsEntityAchievementIds], (achievementIds) => ({ achievementIds }));

export default selectMissionDetailsAchievementsListContainerProps;
